import { useRef, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

import styled from 'styled-components';

// 차트 툴팁을 body로 포탈해 스크롤 컨테이너 overflow에 잘리지 않게 표시하는 공통 컴포넌트 //
// anchorKey가 바뀔 때(다른 지점으로 이동)만 위치 재계산 → 리마운트 없이 CSS transition으로 부드럽게 이동 //
export default function ChartTooltipPortal(props) {
  const { anchorKey, mousePosRef, children } = props;

  const boxRef = useRef(null);

  const [pos, setPos] = useState(null);
  const [isSmooth, setIsSmooth] = useState(false);

  // 커서 위치 기반 배치 + 뷰포트 넘침 클램프 //
  useEffect(() => {
    const el = boxRef.current;

    if (!el) return;

    const rect = el.getBoundingClientRect();
    const gap = 14;

    let left = mousePosRef.current.x + gap;
    let top = mousePosRef.current.y + gap;

    // 오른쪽/아래 뷰포트 넘침 시 반대쪽으로 뒤집거나 경계에 붙임 //
    if (left + rect.width > window.innerWidth - 8) left = mousePosRef.current.x - rect.width - gap;
    if (top + rect.height > window.innerHeight - 8) top = window.innerHeight - rect.height - 8;
    if (left < 8) left = 8;
    if (top < 8) top = 8;

    setPos({ left, top });

    // 첫 배치 이후부터 transition 활성화 (등장 시 -9999에서 슬라이드 방지) //
    const raf = requestAnimationFrame(() => setIsSmooth(true));

    return () => cancelAnimationFrame(raf);
  }, [anchorKey, mousePosRef]);

  return createPortal(
    <PortalLayer
      ref={boxRef}
      $smooth={isSmooth}
      style={pos ? { left: pos.left, top: pos.top } : { left: -9999, top: -9999 }}>
      {children}
    </PortalLayer>,
    document.body
  );
}

const PortalLayer = styled.div`
  position: fixed;

  z-index: 9999;

  pointer-events: none;

  transition: ${props => props.$smooth ? 'left 0.15s ease-out, top 0.15s ease-out' : 'none'};
`;
